import { DefaultRoute } from '../router/routes'
import moment from "moment"
import customAxios from '@api/customAxios'
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import heic2any from 'heic2any'
import { element } from 'prop-types'
const MySwal = withReactContent(Swal)
// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

export const formatDateBD = (value, format = "YYYY-MM-DD") => {
  // Formatea la fecha obtenida desde base de datos
  if (!value) return value
  return  moment(value).format(format)
}
export const contadorLikes = (arr) => { 
  const contador = {
    likes: 0,
    dislikes: 0
  }

  arr.forEach(objeto => {
    if (objeto.tipo) {
      contador.likes += 1
    } else {
      contador.dislikes += 1
    }
  })

  return contador
}

// ** Returns short month of passed date
export const elapsedTime = (startTime) => {
  
  const x        = new Date(startTime)
  const now      = new Date()
  let timeDiff = now - x
  timeDiff    = timeDiff / 1000

  const seconds = Math.round(timeDiff)
  timeDiff    = Math.floor(timeDiff / 60)

  const minutes = Math.round(timeDiff % 60)
  timeDiff    = Math.floor(timeDiff / 60)

  const hours   = Math.round(timeDiff % 24)
  timeDiff    = Math.floor(timeDiff / 24)

  const days    = Math.round(timeDiff % 365)
  timeDiff    = Math.floor(timeDiff / 365)

  const years   = timeDiff

  if (years > 0) {
    return `Hace ${years} ${(years > 1 ? ' años ' : ' año ')} `
  } else if (days > 0) {
    return `Hace ${days} ${(days > 1 ? ' dias ' : ' dia ')} `
  } else if (hours > 0) {
    return `Hace ${hours} ${(hours > 1 ? ' hrs ' : ' hora ')} `
  } else if (minutes > 0) {
    return `Hace ${minutes} ${(minutes > 1 ? ' min ' : ' min ')} `
  } else if (seconds > 0) {
    return `Hace ${seconds} ${(seconds > 1 ? ' seg ' : ' Justo ahora ')} `
  }

  return 'Justo ahora'
}


// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}
/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userData')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === '') return DefaultRoute
  return DefaultRoute

}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})


export const ObjToFormData = (Object) => {
  const formData = new FormData()
  for (const key in Object) {
    console.log('key', key)
    const value = Object[key]
    if (value instanceof Array) {
      formData.append(key, JSON.stringify(value))
    } else {
      formData.append(key, value)
    }
  }
  return formData
}

export const extraerCatalogoDeColeccion = (label, value, coleccion, allData = false) => {
  if (typeof coleccion != 'undefined') {
    if (coleccion.length > 0) {
      const catalogoAux = []
      coleccion.map((element) => {
        let tmpItem = { label: element[label], value: element[value] }
        if (allData) {
          tmpItem = {...tmpItem, ...element}
        }
        catalogoAux.push(tmpItem)
      })
      return catalogoAux
    }
  }
}

export function mensajeSWAL(reload = true) {

  let title = ''
  let text = ''

  switch (accion) {
    case 1:
      title = 'Agregaste un nuevo contacto!'
      text = ""
      break

    case 2:
      //texto de actualizar
      title = 'Modificaste el contacto exitosamente.'
      text = ""
      break

    case 3:
      //texto de actualizar
      title = 'Eliminado!'
      text = 'El contacto fue eliminado correctamente.'
      break

    default:
      break
  }

  MySwal.fire({
    title,
    text,
    icon: "success",
    customClass: {
      confirmButton: "btn btn-primary"
    },
    buttonsStyling: false
  })
  if (reload) {
    load(filtros)
    setVistaDos(false)
  }
}

export const selectFormatoBD = (tipo, item, key_value, key_label) => {
  if (tipo == 1) {
    return {label: item[key_label], value : item[key_value]}
  } else if (tipo == 2) {
    return typeof item == 'object' ? item.value : item
  }
}

export const selectFormatoBDExist = (payload, propiedad) => {
  if (typeof  payload[propiedad] != 'undefined') {
    payload[propiedad] =  (typeof payload[propiedad] == 'object' ? payload[propiedad].value : payload[propiedad])
    return payload
  } else {
    return payload
  }
}

export const copyObject = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}
export const formatoCatalogo = (data) => {
  const aux = []
  if (data) {
    data.forEach(element => {
      const tmp = typeof element == 'string' ? element : (element ? 'Si' : 'No')
      aux.push({label: tmp, value:tmp})
    })
  }
  return aux
}

export const convertToCurrency = (floatValue, signMoney = false) => {
  return `${signMoney ? '$ ' : ''}${floatValue.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`

}

export const formatMoney = (number) => {
  
  return number === '' ? '$ 0' : `$ ${ parseFloat(number).toLocaleString('es-MX', { minimumFractionDigits: 2 }) }`
}

export const getNameMonth = (number = new Date().getMonth()) => {
  const meses = [
    'ENERO',
    'FEBRERO',
    'MARZO',
    'ABRIL',
    'MAYO',
    'JUNIO',
    'JULIO',
    'AGOSTO',
    'SEPTIEMBRE',
    'OCTUBRE',
    'NOVIEMBRE',
    'DICIEMBRE'
  ]
  // Obtener el nombre del mes actual en mayúsculas
  return meses[number]
}
export const getIDActividadesNiveles = (tipo) => {
  switch (tipo) {
    case 'nuevoContacto':   return '6397800e9a39f1d27b5cbcea'; break
    case 'citas':           return '6398c4d6db9b931cb72fe5d0'; break
    case 'eventoRino':      return '6398c520db9b931cb72fe5d3'; break
    case 'nuevosNegocios':  return '63bdb13802e9c0bf2d46d16e'; break
    case 'capacitacion':    return '398c531db9b931cb72fe5d6'; break
    case 'ventas':          return '6398c53cdb9b931cb72fe5d9'; break
    default: break
  }
}


export const getImagen = (uri, set = (uri) => { console.log('No set function provided, URI is:', uri) }) => {
  customAxios
    .get(customAxios.defaults.baseURL + uri, {
      headers: {
        ['x-token']: customAxios.defaults.headers.common['x-token']
      },
      responseType: 'blob'
    })
    .then(async (res) => {
      try {
        const blob = res.data

        // Check if the file is HEIC
        if (blob.type === 'image/heic') {
          // Convert HEIC to JPEG or PNG
          const convertedBlob = await heic2any({ blob, toType: 'image/jpeg' })
          const imageUrl = URL.createObjectURL(convertedBlob)
          set(imageUrl)
        } else {
          // Use the blob as is
          const imageUrl = URL.createObjectURL(blob)
          set(imageUrl)
        }
      } catch (error) {
        console.error('Error handling image:', error)
      }
    })
    .catch((err) => console.error('Error fetching image:', err))
}

export const messageee = (
  {
    title = "Mensaje del sistema",
    text = "",
    time = 5000,
    icon = "info",
    confirmButtonText = "Okay",
    showCancelButton = false,
    confirmFunction = null,
    cancelarFunction = null,
    validarConfirm = false,
    cancelButtonText = "Cancelar"
  }
) => {
  if (confirmFunction != null) {
    MySwal.fire({
      title,
      text,
      confirmButtonText,
      cancelButtonText,
      timerProgressBar: time > 0,
      timer: time,
      icon,
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-danger ms-1'
      },
      showCancelButton,
      buttonsStyling: false
    }).then(function (result) {
      if (validarConfirm) {
        if (result.value) {
          confirmFunction()
        }
      } else {
        if (cancelarFunction) {
          cancelarFunction()
        }
      }
    })
  } else {

    MySwal.fire({
      title,
      text,
      confirmButtonText,
      timerProgressBar: time > 0,
      timer: time,
      icon,
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-danger ms-1'
      },
      showCancelButton,
      buttonsStyling: false
    })
  }
}